import cx from 'classnames';
import CustomText from 'components/common/text/CustomText';
import React from 'react';
import styled from 'styled-components';

export interface IIndicationCard {
  key: string | number;
  label: string;
  typeColor?: string;
  materialImg?: string;
  data?: any;
}

interface IndicationCardProps {
  selectedKey: string | number;
  cardItem: IIndicationCard;
  onClick?: (key: any, data?: any) => void;
}

const IndicationCard = ({ selectedKey, cardItem, onClick }: IndicationCardProps) => {
  return (
    <StyledIndicationCard
      className={cx({ selected: selectedKey === cardItem?.key })}
      onClick={() => !!onClick && onClick(cardItem?.key, cardItem?.data)}
    >
      {!!cardItem?.typeColor && <StyledTypeColor $color={cardItem?.typeColor} />}
      <CustomText style={{ textAlign: 'left' }} fontColor="#444" fontSize={16} fontWeight={400}>
        {cardItem.label}
      </CustomText>
      {!!cardItem?.materialImg && <StyledMaterialImg src={cardItem?.materialImg} />}
    </StyledIndicationCard>
  );
};

const StyledIndicationCard = styled.button`
  width: 100%;
  height: 64px;
  padding: 10px 16px;
  border: 1px solid #e6e6e6;
  flex-basis: 50%;
  display: flex;
  align-items: center;
  position: relative;
  &.selected {
    border: 2px solid #00a6e2;
  }
`;

const StyledTypeColor = styled.div<{ $color: string }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  margin-right: 14px;
  flex-shrink: 0;
`;

const StyledMaterialImg = styled.img`
  position: absolute;
  bottom: 0;
  right: 20px;
`;

export default IndicationCard;
